import React from 'react'
import {
  textWithHTML,
  percentage,
  numberMoney,
  textToNumber,
} from 'Data/format.js'
import { useDataValue } from 'Simple/Data.js'

import View from './view.js'

export default function Logic(props) {
  let ach_fee_percent = useDataValue({
    context: 'payment',
    path: 'ach_fee_percent',
    viewPath: props.viewPath,
  })

  let amount = textToNumber(props.amount)

  return (
    <View
      text={textWithHTML(
        `A <b>platform fee of ${
          amount
            ? `${numberMoney((amount * ach_fee_percent) / 100)} (${percentage(ach_fee_percent)})`
            : percentage(ach_fee_percent)
        }</b> will be applied to ACH payments. By continuing, you acknowledge that the responsible party has authorized this fee.`
      )}
      {...props}
    />
  )
}
